<template>
  <article :class="['post', { 'post--big': big, 'post--vertical': vertical }]">
    <router-link class="post__image" :to="link">
      <img :src="$cmsDomain + post.image">
    </router-link>
    <div class="post__info">
      <span v-if="post.category" class="post__category-name">{{post.category}}</span>
      <h3 :class="['post__title', { 'h1': big, 'h3': vertical, 'h4': !vertical && !big }]">
        <router-link :to="link">{{post.title}}</router-link>
      </h3>
      <p class="post__body" v-if="big" v-html="post.excerpt" />
      <time class="post__created-at">{{formatDate(post.publishedDate)}}</time>
    </div>
  </article>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'Post',
  props: { post: Object, big: Boolean, vertical: Boolean },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name),
    link: app => ({ name: 'BlogPost', params: { id: app.post.url } })
  },
  methods: {
    formatDate (dateString) {
      const date = dayjs(dateString)
      return date.format('MMMM D, YYYY')
    }
  }
}
</script>

<style lang="sass" scoped>
.post
  display: flex
  align-items: center
  &:not(&--big):not(&--vertical)
    padding: 20px 0
    &:not(:last-child)
      border-bottom: solid 1px #E7E7EA

  &--big
    +media-breakpoint-down(md)
      flex-direction: column

  &--vertical
    flex-direction: column

  &__image
    flex: 1
    max-width: 240px
    width: 100%
    +media-breakpoint-down(sm)
      max-width: 210px
    +media-breakpoint-down(xs)
      max-width: 150px

    img
      width: 100%
      height: 100%
      object-fit: cover

  &--big &__image
    max-width: 100%
    +media-breakpoint-up(md)
      max-width: none
      width: 100%
      padding-right: 28px

  &--vertical &__image
    max-width: 100%
    width: 100%

  &__info
    flex: 1
    padding: 28px
    padding-right: 0

  &--big &__info
    padding: 40px 0 40px 28px
    +media-breakpoint-down(sm)
      padding: 28px 0 0 0

  &--vertical &__info
    padding: 28px 0 0 0

  &__category-name
    display: inline-block
    margin-bottom: 7px
    font-size: 12px
    font-weight: bold
    text-transform: uppercase
    letter-spacing: .8px
    color: $primary

  &__title
    margin-bottom: 6px
    a
      color: $dark

  &__body
    margin-top: 18px
    margin-bottom: 10px

  &__created-at
    color: #666B75

</style>



// WEBPACK FOOTER //
// src/components/ui/blog/Post.vue